import { Component } from "react";
import { StyledHeartIcon } from "./styles";
import {
  ConnectedSelectedHeartIcon,
  ConnectedStaticHeartIcon,
} from "@/components/account/uielements";

interface Props {
  label?: string;
  active?: boolean;
  onClick: (favorite: boolean) => void;
  favorites?: boolean;
}

class HeartIcon extends Component<Props> {
  render() {
    const { active, onClick, label, favorites } = this.props;

    return (
      <StyledHeartIcon
        favorites={favorites}
        aria-label={label || "Click to favorite"}
        aria-pressed={active}
        onClick={(e) => {
          e.stopPropagation();
          onClick(!active);
        }}
      >
        {active ? <ConnectedSelectedHeartIcon /> : <ConnectedStaticHeartIcon />}
      </StyledHeartIcon>
    );
  }
}

export default HeartIcon;
